import { withPermissions } from "../../../layout/Permissions";
import { PERMISSION_USER } from "../../user/constants/permissions";
import Calculs from "../containers/Calculs";
import { useSelector } from "react-redux";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import { checkNumberFormat } from "../../../utils/transformer";
import { getAllUserCalculsCall } from "../../../APIClient";
import * as XLSX from "xlsx";
import { useState } from "react";
import { toast } from "react-toastify";

const CalculPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const token = useSelector((state) => state.user.informations.token);
  const userId = useSelector((state) => state.user.informations._id);
  const localConfiguratorId = useSelector(
    (state) => state.configurator.localConfigurator._id,
  );

  const getImpactValue = (value, unit) => {
    const { number, exposant } = checkNumberFormat(value);
    return `${number}${exposant ? <sup>e{exposant}</sup> : ""} ${unit}`;
  };

  const formatCalculsForExport = (calculs) => {
    return calculs.map((calcul) => ({
      "Nom du calcul": calcul.title,
      "Nom du projet": calcul.project,
      "Famille de produit":
        calcul.productFamily?.label || calcul.productFamily?.name || "",
      Version: calcul.lastModel?.version || "",
      Création: format(parseISO(calcul.createdAt), "dd/MM/yyyy HH:mm"),
      Modification: format(parseISO(calcul.updatedAt), "dd/MM/yyyy HH:mm"),
      "Impact CO2":
        calcul.metrics &&
        (calcul.metrics.referenceValue || calcul.metrics.totalGlobalWarming)
          ? calcul.metrics.referenceValue
            ? getImpactValue(
                calcul.metrics.referenceValue,
                calcul.metrics.referenceUnit,
              )
            : getImpactValue(calcul.metrics.totalGlobalWarming, "kg eq. CO2")
          : "0",
    }));
  };

  const exportXlsx = async () => {
    if (!token || !localConfiguratorId || !userId) return;
    try {
      setIsLoading(true);
      const response = await getAllUserCalculsCall(
        token,
        localConfiguratorId,
        userId,
      );
      const ws = XLSX.utils.json_to_sheet(formatCalculsForExport(response));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "mes-calculs.xlsx");
      setIsLoading(false);
    } catch (err) {
      toast.error("Erreur lors de l'export des calculs");
      console.error("Erreur lors du chargement des calculs:", err);
    }
  };

  return <Calculs exportCalculsXlsx={exportXlsx} isExportLoading={isLoading} />;
};
export default withPermissions(CalculPage, PERMISSION_USER);
